import { ApolloClient } from 'apollo-client';
import { HttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloLink, concat } from 'apollo-link';
import { getToken } from './utils';

const httpLink = new HttpLink({
  uri: 'http://localhost:3000/graphql',
});

const authMiddleware = new ApolloLink((operation, forward) => {
  const token = getToken();
  if (token) {
    operation.setContext({
      headers: {
        'x-token': token,
      },
    });
  }
  return forward(operation);
});

export default new ApolloClient({
  link: concat(authMiddleware, httpLink),
  cache: new InMemoryCache(),
});



// WEBPACK FOOTER //
// ./src/ApolloClient.js